import { Font, StyleSheet } from '@react-pdf/renderer'
import interFont from 'assets/fonts/Inter-Regular.ttf'

Font.register({
  family: 'InterFont',
  format: 'truetype',
  src: interFont
})

const styles = StyleSheet.create({
  card: {
    border: '1px solid #cccccc',
    margin: '15px 0',
    padding: 20,
    borderRadius: 2,
    fontFamily: 'InterFont',
    fontWeight: 'bold'
  },
  titleBlock: {
    marginBottom: 15,
    paddingBottom: 5,
    borderBottom: '1px solid #cccccc',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center'
  },
  avatar: {
    marginRight: 18
  },
  heading: { fontSize: 14, marginBottom: 10 },
  introductionStyles: {
    fontSize: 12,
    border: '1px solid #ccc',
    padding: 10,
    marginBottom: 15
  },
  tableRow: {
    fontSize: 12,
    padding: '4px 0',
    borderBottom: '1px solid #cccccc',
    flexDirection: 'row',
    width: '70%',
    justifyContent: 'space-between'
  },
  secondaryText: {
    fontSize: 12,
    color: '#706E83',
    marginBottom: 10,
    width: 410
  },
  ratingWrapper: { flexDirection: 'row' },
  ratingCount: {
    fontSize: 12,
    color: '#222',
    marginLeft: 4,
    fontWeight: 'bold'
  }
})

export default styles
